import { truncate } from 'fs'
import { toCurrency } from '@mortgage-pos/ui/utils/stringFormat'

export const updateRateInputs = (maxCashoutValue = 0) => {
  return [
    {
      name: 'estimatedValue',
      title: '',
      content: '',
      subTitle: 'Property Value',
      component: 'Question-Input',
      infoTitle: '',
      inputType: 'currency',
      maxLength: '',
      visibleIf: '',
      infoContent: '',
      infoWarning: false,
      placeholder: '',
      validations: [
        {
          rules: [
            {
              name: 'required',
              params: '["Input required"]',
              component: 'ValidationRule',
            },
            {
              name: 'min',
              params: '[100000, "Please enter a value above $100,000"]',
              component: 'ValidationRule',
            },
            {
              name: 'typeError',
              params: '["Input required"]',
              component: 'ValidationRule',
            },
          ],
          component: 'Validation',
          condition: [],
          validatorType: 'number',
        },
      ],
      questionName: {
        name: 'estimatedValue',
      },
      modifierClass: '--update-rates',
    },
    {
      name: 'cashOut',
      title: '',
      content: '',
      subTitle: 'Cash Out Amount',
      component: 'Question-Input',
      infoTitle: '',
      inputType: 'currency',
      maxLength: '',
      visibleIf: '',
      infoContent: '',
      infoWarning: true,
      placeholder: '',
      validations: [
        {
          rules: [
            {
              name: 'max',
              params: `[${maxCashoutValue}, "Your maximum cash out is ${toCurrency(
                maxCashoutValue
              )}"]`,
              component: 'ValidationRule',
            },
            {
              name: 'typeError',
              params: '["Input required"]',
              component: 'ValidationRule',
            },
          ],
          component: 'Validation',
          condition: [],
          validatorType: 'number',
        },
      ],
      questionName: {
        name: 'cashOut',
      },
      modifierClass: '--update-rates',
    },
    {
      name: 'remainingBalance',
      title: '',
      content: '',
      subTitle: 'Mortgage Balance',
      component: 'Question-Input',
      infoTitle: '',
      inputType: 'currency',
      maxLength: '',
      visibleIf: '',
      infoContent: '',
      infoWarning: false,
      placeholder: '',
      validations: [
        {
          rules: [
            {
              name: 'required',
              params: '["Input required"]',
              component: 'ValidationRule',
            },
            {
              name: 'min',
              params: '[1, "Please enter a value above $0"]',
              component: 'ValidationRule',
            },
            {
              name: 'typeError',
              params: '["Input required"]',
              component: 'ValidationRule',
            },
          ],
          component: 'Validation',
          condition: [],
          validatorType: 'number',
        },
      ],
      questionName: {
        name: 'remainingBalance',
      },
      modifierClass: '--update-rates',
    },
    {
      name: 'rollInFees',
      title: '',
      content: '',
      defaultYes: false,
      subTitle: 'Roll in Fees',
      component: 'Question-BinaryButton',
      infoTitle: '',
      inputType: 'rollInFees',
      maxLength: '',
      visibleIf: '',
      infoContent: '',
      infoWarning: false,
      questionName: {
        name: 'rollInFees',
      },
      modifierClass: '--update-rates',
      visibleIfConstructor: [],
    },
  ]
}
